import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { primary } from '../../style';
import { updateProfile } from '../../store/actions/userProfileActions';
const drawerWidth = 215;

const styles = theme => ({
  root: {
    display: 'flex'
  },
  drawer: {
    display: 'none',
    width: drawerWidth,
    flexShrink: 0,
    [theme.breakpoints.up('md')]: {
      display: 'flex'
    }
  },
  drawerPaper: {
    width: drawerWidth
  },
  toolbar: {
    height: '70px',
    display: 'flex'
  },
  hpLogo: {
    height: '60px',
    margin: '0 auto',
    cursor: 'pointer'
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default
  },
  listItem: {
    marginTop: '12px',
    cursor: 'pointer'
  },
  listItem_active: {
    color: primary
  },
  listItem__icon: {
    minWidth: '32px'
  },
  discordImageContainer: {
    position: 'absolute',
    bottom: '0',
    margin: '0 auto',
    alignSelf: 'center',
    marginBottom: '10px'
  },
  discordImage: {
    height: '40px',
    width: '120px'
  },
  hiddenDrawer: {
    display: 'none'
  }
});

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile
  };
};

const mapDispatchToProps = dispatch => {
  return {
    resetUnreadMessagesHandler: () =>
      dispatch(updateProfile({ unReadMessages: 0 }))
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withProps(({ auth, profile }) => ({
    auth,
    profile
  })),
  withRouter,
  withStyles(styles)
);



// WEBPACK FOOTER //
// ./src/components/layout/SideNav.enhancer.js